import hooks from "./hooks";

const postHook = store => {
  store.subscribe(() => {
    hooks.forEach(hook => hook(store));
  });
};

export default postHook;
